import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { TDialog, TDialogTitle, TDialogForm } from "../../Common/TDialog";

const ActivateAccountCompleteDialog = (props) => {
    return (
        <TDialog open={props.open}>
            <TDialogTitle>Account verified</TDialogTitle>

            <TDialogForm>
                <Typography variant="body1">
                    Your account has been verified. You can now sign in to{" "}
                    <a href={props.applicationUrl}>{props.applicationName}</a>.
                </Typography>
            </TDialogForm>
            {/* <TDialogActions>
                <Button color="primary" disabled={props.saving} onClick={props.onClose}>
                    Ok
                </Button>
            </TDialogActions> */}
        </TDialog>
    );
};

ActivateAccountCompleteDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    applicationName: PropTypes.string,
    applicationUrl: PropTypes.string,
};

export default ActivateAccountCompleteDialog;
